import { useTranslation } from 'react-i18next';

import Product from 'components/product/Product';
import {getData} from 'components/product/util';

import img1 from 'assets/images/solutions/inverters/sr/inverter_1.jpg'
import img2 from 'assets/images/solutions/inverters/sr/inverter_2.jpg'
import img3 from 'assets/images/solutions/inverters/sr/inverter_3.jpg'
import img4 from 'assets/images/solutions/inverters/sr/inverter_4.jpg'
import img5 from 'assets/images/solutions/inverters/sr/inverter_5.jpg'

export default function ProductSr(){
  const {t} = useTranslation();
  const products = getData(t, "inverters", "sr");
 
  // 그림 이름은 대중이 없어서 따로 넣어야 함.
  products[0].images = [img1];
  products[1].images = [img2];
  products[2].images = [img3];
  products[3].images = [img4];
  products[4].images = [img5];

  return (
    <Product products={products}/>
  );
}